module.exports = __webpack_public_path__ + "img/banner.b09c723.png";